import { View } from 'react-native'
import { styled } from '~/utils'

export const useTooltipArrowStyles = () => {
  const Wrapper = styled(View, theme => {
    return {
      base: {
        justifyContent: 'center',
        zIndex: theme.zindexOverlay + 1,
      },
      variants: {
        side: {
          bottom: {
            width: '100%',
            top: 1,
            alignItems: 'flex-start',
          },
          top: {
            width: '100%',
            top: 1,
            alignItems: 'flex-start',
          },
          left: {
            height: '100%',
            left: 6,
            alignItems: 'center',
          },
          right: {
            height: '100%',
            right: -6,
            alignItems: 'center',
          },
        },
      },
    }
  })

  const Arrow = styled(View, theme => {
    return {
      base: {
        position: 'relative',
        width: theme.sizingTiny,
        height: theme.sizingMicro,
      },
      variants: {
        side: {
          bottom: {
            transform: [{ rotate: '180deg' }],
          },
          top: {},
          left: {
            transform: [{ rotate: '270deg' }],
          },
          right: {
            transform: [{ rotate: '90deg' }],
          },
        },
      },
    }
  })

  return {
    Wrapper,
    Arrow,
  }
}
